<template>
  <div class="bg-secondary-3">
    <div class="py-1 px-4 rounded">
      <div class="row mt-4">
        <div class="col-12 d-flex">
          <i class="fas fa-calendar-plus text-orange mr-2 mt-1"></i>
          <p class="font-weight-normal font-18">
            Discusión de Informe de Progreso
          </p>
        </div>
      </div>
      <ValidationObserver ref="academicProgressDiscussion">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-md-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="date"
                  rules="required"
                >
                  <custom-date-picker
                    v-model="model.dateDiscussion"
                    required
                    label="Fecha de Discusión"
                    placeholder="DD/MM/YYYY"
                    :min-date="minDate"
                    :max-date="new Date()"
                    :error="errors[0]"
                    custom-error-msg="La fecha de discusión es requerida."
                  />
                </ValidationProvider>
              </div>
              <div class="col-12 col-md-4">
                <span>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <label class="color-gray-6 font-14 font-weight-bold">
                      Archivo:
                    </label>
                    <custom-file-input
                      ref="fileUpload"
                      v-model="model.fileDiscussion"
                      display-style="normal"
                      :on-download="downloadFile"
                      :accept="'.pdf'"
                      label-position="left"
                      :error="errors[0]"
                      custom-error-msg="El documento es requerido."
                    />
                  </validation-provider>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="main-content mt-2">
              <div class="mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="reason"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.comment"
                    required
                    :maxlength="3000"
                    label="Comentario:"
                    :error="errors[0]"
                    :custom-error-msg="'El Comentario es requerido'"
                    show-char-count
                    :count-classes="['d-block', 'small-counter', 'text-right']"
                  />
                </ValidationProvider>
              </div>
              <div class="d-flex justify-content-end align-items-center px-0">
                <action-button
                  type="button"
                  text="Cancelar"
                  i="fa fa-times-circle"
                  variant="outline-danger"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="close()"
                />

                <action-button
                  type="button"
                  text="Guardar"
                  i="fas fa-save"
                  variant="success"
                  class="ml-2 px-4 mb-3 actionButton"
                  @click="save()"
                />
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import peiService from "@/services/pei/peiAcademicProgressCalendar.js";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import CustomDatePicker from "custom-date-picker";
import CustomFileInput from "CustomFileInput";
import alert from "@/mixin/alert.mixin";
import objectToFormData from "object-to-formdata";

export default {
  name: "AcademicProgressDiscussion",
  components: {
    ValidationProvider,
    ValidationObserver,
    CustomTextArea,
    ActionButton,
    CustomDatePicker,
    CustomFileInput
  },
  data: () => ({
    model: {
      dateDiscussion: null,
      fileDiscussion: null,
      comment: null
    }
  }),
  mixins: [alert],
  mounted() {},
  props: {
    academicProgressId: {
      type: Number,
      default: null,
      require: true
    },
    minDate: {
      type: Date,
      default: null,
      require: true
    }
  },
  methods: {
    downloadFile() {},
    async save() {
      const isValid = await this.$refs.academicProgressDiscussion.validate();

      if (!isValid) {
        this.ShowToast(
          "Error",
          "Favor de completar la información solicitada.",
          "error"
        );
        return;
      }

      const model = {
        academicProgressId: this.academicProgressId,
        ...this.model
      };

      const formData = objectToFormData(model, { indices: true });

      await peiService.saveDiscussion(formData).then(
        () => {
          this.ShowToast(
            "Proceso exitoso.",
            "La discusión se ha guardado correctamente.",
            "success"
          );
          this.model.dateDiscussion = null;
          this.model.fileDiscussion = null;
          this.model.comment = null;
          this.$emit("saved");
        },
        error => {
          this.ShowToast("Alerta", `${error.response.data.message}.`, "error");
          return { data: false };
        }
      );
    },
    async close() {
      this.model.dateDiscussion = null;
      this.model.fileDiscussion = null;
      this.model.comment = null;
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss" scoped></style>
